import { combineReducers } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { IBuilderActions } from './builder/actions';
import { IBuilderState, reducer as builder } from './builder/reducer';
import { IModalAction } from './modal/actions';
import { IModalState, reducer as modal } from './modal/reducer';

export * from './builder/actions';
export * from './modal/actions';
export type { IModal } from './modal/reducer';

export interface IState {
    modal: IModalState;
    builder: IBuilderState;
}

export type Thunk<T> = ThunkAction<Promise<T>, IState, void, IAction>;

export const reducer = combineReducers({
    builder,
    modal,
});

export type IAction =
    | IModalAction
    | IBuilderActions;

export type IDispatch = ThunkDispatch<IState, void, IAction>;

export interface DispatchProp {
    dispatch: IDispatch;
}
